'use strict';

angular.module('shiftTraderApp')
  .directive('clickToEdit', function () {
    var editorTemplate = '<div class="click-to-edit">' +
      '<div ng-hide="cte.view.editorEnabled">' +
      '<span ng-if="!cte.link && cte.value">{{ cte.value }}</span>' +
      '<a ng-if="cte.link && cte.value" href="{{cte.value}}" class="sa_link sa_blue sa_darktheme" target="_blank">{{ cte.value }}</a> ' +
      '<span ng-if="!cte.value" style="color:#555;">{{ cte.emptyText }}</span>' +
      '<div class="click-to-edit-enable sa_hover sa_lighttheme"><i ng-click="cte.enableEditor()" class="sa-icon-edit"></i></div>' +
      '</div>' +
      '<div ng-show="cte.view.editorEnabled">' +
      '<input ng-model="cte.view.editableValue" ng-if="!cte.link" class="sa_input sa_lighttheme"><input ng-model="cte.view.editableValue" ng-if="cte.link" class="sa_input sa_darktheme" placeholder="https://">' +
      '<button ng-click="cte.save()" class="click-to-edit-save sa_button sa_small sa_gray">Save</button>' +
      '<button class="click-to-edit-cancel-wrapper"><i ng-click="cte.disableEditor()" class="icon-remove"></i></button>' +
      '</div>' +
      '</div>';

    return {
      restrict: 'A',
      replace: true,
      template: editorTemplate,
      controllerAs: 'cte',
      bindToController: true,
      scope: {
        value: '=clickToEdit',
        link: '@',
        emptyText: '@',
        updateFn: '&'
      },
      controller: function() {
        var vm = this;
        vm.view = {
          editableValue: vm.value,
          editorEnabled: false
        };

        vm.enableEditor = function() {
          vm.view.editorEnabled = true;
          vm.view.editableValue = vm.value;
        };

        vm.disableEditor = function() {
          vm.view.editorEnabled = false;
        };

        vm.save = function() {
          vm.updateFn({val: vm.view.editableValue})
            .then(function() {
              vm.value = vm.view.editableValue;
              vm.disableEditor();
            });
        };
      }
    };
  });
